import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Sidebar } from "../components/Sidebar";

const GeographicalSeo = () => {
  return (
    <>
      <Header />

      {/* <!--hero section start--> */}
	  
	  
	  <section class="page-title">
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-10">
        <h1>
     GEO (Geographical SEO)


        </h1>
        
      </div>
    </div>
  </div>
  <div class="page-title-wave">
    <img src="./assets/images/page-bg.svg" alt="" />
  </div>
</section>
	  
	
	
	  <div class="page-content">

	  <section>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-8 mb-10 mb-lg-0 order-lg-1">
        <div class="service-image mb-5">
          <img class="img-fluid rounded" src="./assets/images/service/large/01.png" alt="..." />
        </div>
        <h3>GEO (Geographical SEO)</h3>
        <p class="ht-first-letter">Get discovered by customers near you.
Our GEO optimization ensures your business dominates local searches in Qatar, Google Maps results, and location-based platforms — ideal for restaurants, retail, and service-based companies.
</p>
		  <h5>We focus on:</h5>
     
        <div class="row mt-4">
          <div class="col-md-6">
            <ul class="list-unstyled list-icon style-2">
              <li>
                <i class="flaticon flaticon-check-mark"></i>Structured Data & Schema Markup
              </li>
              <li>
                <i class="flaticon flaticon-check-mark"></i>Voice Search Optimization
              </li>
              
              
             
            </ul>
          </div>
          <div class="col-md-6 mt-3 mt-md-0">
            <ul class="list-unstyled list-icon style-2">
              <li>
                <i class="flaticon flaticon-check-mark"></i>Featured Snippets Targeting
              </li>
              <li>
                <i class="flaticon flaticon-check-mark"></i>Conversational Content Strateg
              </li>
            </ul>
          </div>
        </div>
        <div class="row my-7">
          <div class="col-md-6">
            <div class="featured-item style-2">
              <div class="featured-item-top d-sm-flex align-items-center">
                <div class="featured-icon flex-shrink-0">
                  <img class="img-fluid" src="./assets/images/feature/04.png" alt="" />
                </div>
                <div class="featured-title flex-grow-1">
                  <h4>SEO Analytics</h4>
                </div>
              </div>
              <div class="featured-desc">
                <p>Get high rankings with multi-team collaboration help you optimize SEO.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-5 mt-md-0">
            <div class="featured-item style-2">
              <div class="featured-item-top d-sm-flex align-items-center">
                <div class="featured-icon flex-shrink-0">
                  <img class="img-fluid" src="./assets/images/feature/05.png" alt="" />
                </div>
                <div class="featured-title flex-grow-1">
                  <h4>Social Marketing</h4>
                </div>
              </div>
              <div class="featured-desc">
                <p>Get high rankings with multi-team collaboration help you optimize SEO.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-5">
            <div class="featured-item style-2">
              <div class="featured-item-top d-sm-flex align-items-center">
                <div class="featured-icon flex-shrink-0">
                  <img class="img-fluid" src="./assets/images/feature/06.png" alt="" />
                </div>
                <div class="featured-title flex-grow-1">
                  <h4>Creative Ideas</h4>
                </div>
              </div>
              <div class="featured-desc">
                <p>Get high rankings with multi-team collaboration help you optimize SEO.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-5">
            <div class="featured-item style-2">
              <div class="featured-item-top d-sm-flex align-items-center">
                <div class="featured-icon flex-shrink-0">
                  <img class="img-fluid" src="./assets/images/feature/07.png" alt="" />
                </div>
                <div class="featured-title flex-grow-1">
                  <h4>SEO Optimization</h4>
                </div>
              </div>
              <div class="featured-desc">
                <p>Get high rankings with multi-team collaboration help you optimize SEO.</p>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="col-12 col-lg-4 pe-lg-8">
		  
		    <Sidebar />
     
      </div>
    </div>
  </div>
</section>
	
	  
	  
	  
	
	  

        {/* <!--about end--> */}
		  
		  
      </div>
      {/* <!--body content end-->  */}

      <Footer />

      {/* <!--back-to-top start--> */}
      <div className="scroll-top">
        <svg
          className="scroll-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
      {/* <!--back-to-top end--> */}
    </>
  );
};

export default GeographicalSeo;
